import apiClient from './apiClient';

// LabelRequest corresponds to backend models.LabelRequest
export interface LabelRequest {
  invoice_no: string;    // TJ30B_01 C(10) Invoice no.
  order_no: string;      // TJ30B_11 C(10) Order no.
  article: string;       // TJ30B_12 C(13) Article（品號）
  color: string;         // TJ30B_13 C(15) Color（顏色代號）
  finish: string;        // TJ30B_14 Memo  Finish（後整理說明）
  piece_no: string;      // TJ30B_15 C(6)  Piece no.（隱藏欄位）
  qty_m: string;         // TJ30B_16 C(5)  Qty in M（公制數量）
  grade: string;         // TJ30B_17 C(6)  Grade（等級代碼）
  label_date: string | null; // TJ30B_18 D Date（日期）ISO string
  inspector: string;     // TJ30B_19 C(6)  Insp（檢驗員代號）
  qty_yd: string;        // TJ30B_20 C(5)  Qty in yd（碼制數量）
  print_copies: number;  // PR_S_PAGE 列印份數 default=10
}

// LabelRecord corresponds to backend models.LabelRecord
export interface LabelRecord {
  invoice_no: string;
  order_no: string;
  article: string;
  color: string;
  finish: string;
  piece_no: string;
  qty_m: string;
  grade: string;
  label_date: string | null;
  inspector: string;
  qty_yd: string;
}

// PrintResult corresponds to backend models.PrintResult
export interface PrintResult {
  records: LabelRecord[];
  total_count: number;
  print_copies: number;
}

export const pwj30bApi = {
  async preview(req: LabelRequest): Promise<PrintResult> {
    const res = await apiClient.post('/api/pwj30b/preview', req);
    return res.data;
  },

  async print(req: LabelRequest): Promise<PrintResult> {
    const res = await apiClient.post('/api/pwj30b/print', req);
    return res.data;
  },
};
